import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class CpuUnitConverter extends UnitConverter<(typeof UnitOptions)['CPU'][number]['value']> {
  // 싱글턴 인스턴스
  private static instance: CpuUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): CpuUnitConverter {
    if (!CpuUnitConverter.instance) {
      CpuUnitConverter.instance = new CpuUnitConverter();
    }
    return CpuUnitConverter.instance;
  }

  protected units = [
    'nanocore (ncores)',
    'microcore (μcores)',
    'millicore (mcores)',
    'core',
    'kilocore (Kcores)',
    'megacore (Mcores)',
    'gigacore (Gcores)',
    'teracore (Tcores)',
    'petacore (Pcores)',
    'exacore (Ecores)',
  ] as const;

  protected unitToBase = {
    'nanocore (ncores)': 1e-9,
    'microcore (μcores)': 1e-6,
    'millicore (mcores)': 1e-3,
    core: 1,
    'kilocore (Kcores)': 1e3,
    'megacore (Mcores)': 1e6,
    'gigacore (Gcores)': 1e9,
    'teracore (Tcores)': 1e12,
    'petacore (Pcores)': 1e15,
    'exacore (Ecores)': 1e18,
  };
}
